import { Routes } from '@angular/router';
import { DEV_ROUTES } from './dev/dev.routes';

export const pageRoutes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
        data: {
            breadcrumb: 'Dashboard'
        }
    },
    {
        path: 'agenda',
        loadChildren: () => import('./agenda/agenda.module').then(m => m.AgendaModule),
        data: {
            breadcrumb: 'Agenda'
        }
    },
    {
        path: 'cadastros',
        loadChildren: () => import('./cadastros/cadastros.route').then(m => m.CADASTROS_ROUTES),
        data: {
            breadcrumb: 'Cadastros'
        }
    },
    {
        path: 'cs',
        loadChildren: () => import('./cs/cs.route').then(m => m.CS_ROUTES),
        data: {
            breadcrumb: 'Custumer Success'
        }
    },
    {
        path: 'financeiro',
        loadChildren: () => import('./financeiro/financeiro.route').then(m => m.FINANCEIRO_ROUTES),
        data: {
            breadcrumb: 'Financeiro'
        }
    },
    {
        path: 'suporte',
        loadChildren: () => import('./suporte/suporte.route').then(m => m.SUPORTE_ROUTES),
        data: {
            breadcrumb: 'Suporte'
        }
    },
    {
        path: 'perfil',
        loadChildren: () => import('./perfil/perfil.module').then(m => m.PerfilModule),
        data: {
            breadcrumb: 'Perfil'
        }
    },
    {
        path: 'servicos',
        loadChildren: () => import('./servicos/servicos.routes').then(m => m.SERVICOS_ROUTES),
        data: {
            breadcrumb: 'Serviços'
        }
    },
    {
        path: 'historico-versoes',
        loadChildren: () => import('./versionamento/versionamento.module').then(m => m.VersionamentoModule),
        data: {
            breadcrumb: 'Versoes'
        }
    },
    // Vazio fora do `ng serve` local (ver dev/dev.routes.ts).
    ...DEV_ROUTES
];
